import { Navigate } from "react-router-dom";

export default function Error404() {
  return <Navigate to="/" />;
}
